import type { SVGProps } from "react";
export interface CarrotIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CarrotIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CarrotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.205 14.205a1.125 1.125 0 0 1 1.505-.078l.085.078 2.501 2.5.076.086a1.124 1.124 0 0 1-1.582 1.582l-.085-.078-2.5-2.5-.078-.085a1.125 1.125 0 0 1 .078-1.505m-6 0a1.125 1.125 0 0 1 1.506-.078l.084.078 1.5 1.5.078.085a1.126 1.126 0 0 1-1.583 1.582l-.085-.076-1.5-1.5-.078-.086a1.125 1.125 0 0 1 .078-1.505m5-7a1.126 1.126 0 0 1 1.505-.078l.085.078 2.5 2.5.078.085a1.126 1.126 0 0 1-1.583 1.582l-.085-.076-2.5-2.5-.077-.086a1.125 1.125 0 0 1 .076-1.505Zm5.054-.95V3.557A2.684 2.684 0 0 1 15.943.875a2.67 2.67 0 0 1 2.276 1.267 2.75 2.75 0 0 1 2.86.37l.21.188.006.005.19.21c.668.82.79 1.934.37 2.864a2.68 2.68 0 0 1 1.27 2.278c0 1.482-1.2 2.683-2.682 2.684h-2.698a1.125 1.125 0 0 1 0-2.25h2.698a.433.433 0 0 0 0-.866h-.653A1.125 1.125 0 0 1 19 5.699l.705-.696a.5.5 0 0 0 .004-.702l-.083-.067a.49.49 0 0 0-.63.061L18.3 5a1.125 1.125 0 0 1-1.926-.79v-.653a.434.434 0 0 0-.866 0v2.698a1.125 1.125 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M12.6 4.88c1.77-.074 3.42.656 4.642 1.877 1.221 1.221 1.951 2.871 1.878 4.642-.07 1.674-.85 3.34-2.394 4.763l-.32.28c-2.01 1.698-4.929 3.723-7.603 5.085-1.33.678-2.663 1.226-3.826 1.465-1.06.218-2.396.262-3.29-.637l-.002.001-.02-.022q-.012-.01-.022-.02l.001-.002c-.898-.894-.854-2.228-.636-3.288.24-1.164.787-2.495 1.465-3.826 1.363-2.675 3.387-5.594 5.085-7.606l.281-.318c1.422-1.543 3.087-2.325 4.76-2.395Zm.094 2.248c-1.063.044-2.279.566-3.418 1.916-1.602 1.898-3.525 4.674-4.799 7.175-.64 1.256-1.084 2.382-1.264 3.259-.149.723-.076 1.05-.02 1.178l.04.069.043.042c.025.026.287.218 1.247.02.876-.18 2.002-.625 3.259-1.265 2.5-1.274 5.276-3.197 7.175-4.799 1.349-1.139 1.871-2.354 1.916-3.416.044-1.076-.397-2.132-1.222-2.957-.826-.826-1.881-1.267-2.957-1.222"
      />
    </svg>
  );
}
